import { gatewayPhone } from "src/gateways/gatewayPhone";

export interface UsageSummaryResponse {
  phoneNumber: string;
  period: {
    start: string | null;
    end: string | null;
    billingPeriod: string | null;
  };
  calls: {
    inboundMinutes: number;
    outboundMinutes: number;
    totalMinutes: number;
  };
  sms: {
    inboundCount: number;
    outboundCount: number;
    totalCount: number;
  };
}

interface GetUsageSummaryParams {
  phoneNumber: string;
  billingPeriod?: string;
}

export const getUsageSummary = async ({
  phoneNumber,
  billingPeriod,
}: GetUsageSummaryParams): Promise<UsageSummaryResponse> => {
  const { data } = await gatewayPhone.get<UsageSummaryResponse>("/usage/summary", {
    params: {
      phoneNumber,
      ...(billingPeriod ? { billingPeriod } : {}),
    },
  });

  return data;
};
